import tw from 'tailwind-styled-components'
import {State} from './types'

export const TwChips = tw.div<{$forceState?: State}>`
  cursor-pointer
  select-none

  py-4
  px-10
  rounded-full
  text-xs-regular
  
  flex
  items-center
  gap-4
  
  ${p => {
    const cs: string[] = []
    if (!p.$forceState) {
      cs.push(
        'bg-sticker-blue',
        'text-secondary',
        'hover:shadow-border-1',
        'hover:shadow-action-default',
        'hover:text-action-default',
        'active:bg-action-default',
        'active:text-invert'
      )
    } else if (p.$forceState === 'default') {
      cs.push('bg-sticker-blue', 'text-secondary')
    } else if (p.$forceState === 'hover') {
      cs.push('shadow-border-1', 'shadow-action-default', 'text-action-default')
    } else if (p.$forceState === 'active') {
      cs.push('bg-action-default', 'text-invert')
    }
    return cs.join(' ')
  }}
`
